import { render } from "./Sort.vue?vue&type=template&id=70dffec8&scoped=true"
import script from "./Sort.vue?vue&type=script&lang=js"
export * from "./Sort.vue?vue&type=script&lang=js"

import "./Sort.vue?vue&type=style&index=0&id=70dffec8&lang=scss&scoped=true"

import exportComponent from "/home/airsxm/domains/airsxm.ridders.dev/public_laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70dffec8"]])

export default __exports__